/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'

import { formatFileDuplicates } from '../../assets/ts/formatting/formatting'
import { FILE_CHARACTERS_UNALLOWED } from '../../assets/ts/general/general'
import { FILE_EXTENSIONS } from '../../utils/constants/global-constants'
import { FILENAME_REGEX } from '../../utils/constants/rhybus-config'
import InputLabel from '../../utils/controls/input-label'
import Alert from '../alert/alert'
import './fileupload.css'

interface Props {
  clearFiles?: boolean
  duplicateFileNames?: any
  fileError?: boolean
  filesProps: any
  formClassName?: string
  hint?: any
  hintClassName?: any
  info?: any
  infoClassName?: any
  infoIcon?: any
  inputProps?: any
  isInfo?: any
  isMandatory?: any
  isVisible?: boolean | undefined
  label?: string
  note?: any
  noteClassName?: any | string | undefined
  onFileChange: any
  replaceFileProps: any
  setFileError?
}
const FileUpload = (props: Props) => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const attachmentRef = useRef<HTMLDivElement>(null)
  const [fileList, setFileList] = useState([])
  const [lastUploadedFile, setLastUploadedFile] = useState()

  const [duplicateError, setDuplicateError] = useState(false)
  const [invalidFileError, setInvalidFileError] = useState(false)
  const [invalidFileNameError, setInvalidFileNameError] = useState(false)
  const [noFilesError, setNoFilesError] = useState(false)
  const [over10FilesError, setOver10FilesError] = useState(false)

  const [listOfErrors, setListOfErrors] = useState({
    duplicates: [],
    invalidFileNames: [],
    invalidFiles: [],
  })

  const onDragEnter = () => {
    wrapperRef.current?.classList.add('dragover')
    attachmentRef.current?.classList.add('drag-file')
  }
  const onDragLeave = () => {
    wrapperRef.current?.classList.remove('dragover')
    attachmentRef.current?.classList.remove('drag-file')
  }

  const onRespondClick = (userDecision: 'Cancel' | 'Replace'): void => {
    if (userDecision === 'Replace') {
      setDuplicateError(false)
      props.replaceFileProps.setReplaceFile(true)
      props.setFileError(false)
    } else {
      setDuplicateError(false)
      props.replaceFileProps.setReplaceFile(false)
      props.setFileError(false)
    }
  }
  const addFileHandler = (e) => {
    setDuplicateError(false)
    document.getElementById('attachFile')
  }
  const onFileDrop = (e: any) => {
    let updatedList: any[] = []
    setDuplicateError(false)
    setInvalidFileError(false)
    setInvalidFileNameError(false)
    setNoFilesError(false)
    setListOfErrors({
      duplicates: [],
      invalidFileNames: [],
      invalidFiles: [],
    })
    const targetFiles = e.target.files
    for (let index = 0; index < targetFiles.length; index++) {
      const newFile = targetFiles.item(index)
      const existsInCurrentUpload = fileList?.map((x: any) => x.name)
      // Checking for invalid files
      const fileExtension = newFile.name.substring(newFile.name.lastIndexOf('.')).toLowerCase()
      if (!FILE_EXTENSIONS.includes(fileExtension)) {
        updateErrorList('invalidFiles', true, newFile?.name)
        setInvalidFileError(true)
        setInvalidFileNameError(false)
        setDuplicateError(false)
        setNoFilesError(false)
      } else {
        if (FILENAME_REGEX.test(newFile.name)) {
          updateErrorList('invalidFileNames', true, newFile?.name)
          setInvalidFileNameError(true)
          setDuplicateError(false)
          setInvalidFileError(false)
          setNoFilesError(false)
        } else if (!existsInCurrentUpload.includes(newFile.name) && newFile) {
          updatedList = [...updatedList, newFile]
          const allAttachments = fileList.concat(updatedList)
          setFileList(allAttachments)
          props?.filesProps.setFiles(allAttachments)
          setNoFilesError(false)
          setLastUploadedFile(newFile)
        } else if (targetFiles.length > 10) {
          props?.filesProps.setFiles(true)
          setOver10FilesError(true)
          setNoFilesError(false)
        } else {
          updateErrorList('duplicates', true, newFile.name)
          setDuplicateError(true)
          setInvalidFileError(false)
          setInvalidFileNameError(false)
          setNoFilesError(false)
          props.setFileError(true)
          setLastUploadedFile(newFile)
        }
        if (props?.duplicateFileNames?.includes(newFile.name)) {
          updateErrorList('duplicates', true, newFile.name)
          setDuplicateError(true)
          setInvalidFileError(false)
          setInvalidFileNameError(false)
          setNoFilesError(false)
          props.setFileError(true)
          setLastUploadedFile(newFile)
        }
      }
    }
    const allAttachments = fileList.concat(updatedList)
    setFileList(allAttachments)
    props?.filesProps.setFiles(allAttachments)
    if (props?.onFileChange) {
      props?.onFileChange(allAttachments)
    }
    e.target.value = null
  }
  const handleDrop = (e: any) => {
    e.preventDefault()
    wrapperRef.current?.classList.remove('dragover')
    attachmentRef.current?.classList.remove('drag-file')
    if (!e) return
    let updatedList: any[] = []
    const files = e.dataTransfer.files
    const newFiles: any[] = Array.from(files)
    setDuplicateError(false)
    setInvalidFileError(false)
    setInvalidFileNameError(false)
    setNoFilesError(false)
    setListOfErrors({
      duplicates: [],
      invalidFileNames: [],
      invalidFiles: [],
    })
    for (const newFile of newFiles) {
      const existsInCurrentUpload = fileList.map((x: any) => x.name)
      // Checking for invalid files
      const fileExtension = newFile.name.substring(newFile.name.lastIndexOf('.')).toLowerCase()

      if (!FILE_EXTENSIONS.includes(fileExtension)) {
        updateErrorList('invalidFiles', true, newFile?.name)
        setInvalidFileError(true)
        setDuplicateError(false)
        setInvalidFileNameError(false)
        setNoFilesError(false)
      } else {
        if (FILENAME_REGEX.test(newFile.name)) {
          updateErrorList('invalidFileNames', true, newFile?.name)
          setInvalidFileNameError(true)
          setInvalidFileError(false)
          setDuplicateError(false)
          setNoFilesError(false)
        } else if (!existsInCurrentUpload.includes(newFile.name) && newFile) {
          updatedList = [...updatedList, newFile]
          setLastUploadedFile(newFile)
        } else if (props?.duplicateFileNames?.includes(newFile?.name)) {
          updateErrorList('duplicates', true, newFile.name)
          setDuplicateError(true)
          setInvalidFileError(false)
          setInvalidFileNameError(false)
          setNoFilesError(false)
          props.setFileError(true)
          setLastUploadedFile(newFile)
        } else {
          updateErrorList('duplicates', true, newFile.name)
          setDuplicateError(true)
          setInvalidFileError(false)
          setInvalidFileNameError(false)
          setNoFilesError(false)
          props.setFileError(true)
          setLastUploadedFile(newFile)
        }
      }
    }

    const allAttachments = fileList.concat(updatedList)
    setFileList(allAttachments)
    props?.filesProps.setFiles(allAttachments)
    if (props?.onFileChange) {
      props?.onFileChange(allAttachments)
    }
  }
  const fileRemove = (file: any) => {
    const updatedList = [...fileList]
    updatedList.splice(fileList.indexOf(file), 1)
    props?.filesProps.setFiles(updatedList)
    setFileList(updatedList)
    setInvalidFileError(false)
    setInvalidFileNameError(false)
    if (props?.onFileChange) {
      props?.onFileChange(updatedList)
    }
  }

  const invalidFileErrorMessage = (
    <p>
      Invalid file format. Please select a file with one of the following extensions: .xlsx, .xls,
      .doc, .docx, .ppt, .pptx, .txt, .pdf, .png, .jpg, .jpeg, .gif, .msg
    </p>
  )
  const invalidFileNameErrorMessage = (
    <p className='ps-3 font-12'>
      File name contains unallowed characters. Unallowed characters are $
      {FILE_CHARACTERS_UNALLOWED.join(' ')}.`
    </p>
  )
  const noFilesExistErrorMessage = (
    <div className='drop-file-input'>
      <span className='Spanerrormsgs' id='docerrormsg' style={{ verticalAlign: 'bottom' }}>
        <p className='errormsg'>Please Choose/Drag file(s) to upload.</p>
      </span>
    </div>
  )
  const over10FilesErrorMessage = (
    <div className='drop-file-input'>
      <span className='Spanerrormsgs' id='docerrormsg' style={{ verticalAlign: 'bottom' }}>
        <p className='errormsg'>Only 10 Files can be uploaded at a time.</p>
      </span>
    </div>
  )
  const renderErrorMessages = () => {
    let errorMessages

    if (invalidFileNameError && listOfErrors.invalidFileNames?.length > 0) {
      errorMessages = (
        <div className='error-container' key='invalidFileNames'>
          <h4 className='error-label mt-3'>Errors:</h4>
          <ul className='error-list'>
            {listOfErrors.invalidFileNames.map((fileName, index) => (
              <li key={`invalid-name-${index}`}>{fileName}</li>
            ))}
          </ul>
        </div>
      )
    }

    if (invalidFileError && listOfErrors.invalidFiles?.length > 0) {
      errorMessages = (
        <div className='error-container' key='invalidFiles'>
          <h4 className='error-label mt-3'>Errors:</h4>
          <ul className='error-list'>
            {listOfErrors.invalidFiles.map((fileName, index) => (
              <li className='error-file' key={`invalid-file-${index}`}>
                {fileName}
              </li>
            ))}
          </ul>
        </div>
      )
    }

    return errorMessages ? <div className='error-messages'>{errorMessages}</div> : null
  }

  const getItemName = (item) => {
    return item.name ? item.name : item.fileName
  }
  const addFilePopup = (e: Event) => {
    e.stopPropagation()
  }
  const renderFileNameWithIcon = (fileName) => {
    // Extract the file extension
    let fileExtension = fileName.split('.').pop()

    // Convert 'xlsx' to 'excel'
    if (fileExtension === 'xlsx') {
      fileExtension = 'excel'
    }
    if (fileExtension === 'docx') {
      fileExtension = 'worddoc'
    }
    if (fileExtension === 'pptx') {
      fileExtension = 'pptdoc'
    }
    if (fileExtension === 'png') {
      fileExtension = 'file-picture'
    }
    // Extract the file name without the extension
    const nameWithoutExtension = fileName.slice(0, fileName.lastIndexOf('.'))
    // Return a JSX element with the appropriate structure
    return (
      <span>
        <span className={`icon-${fileExtension}`}></span>
        {nameWithoutExtension}
      </span>
    )
  }

  const updateErrorList = (errorType, errorState, fileName) => {
    setListOfErrors((prevErrors) => {
      // Only update the error list if the error just became true
      if (errorState) {
        return {
          ...prevErrors,
          [errorType]: [...prevErrors[errorType], fileName],
        }
      }
      return prevErrors
    })
  }

  useEffect(() => {
    setFileList([])
  }, [props?.clearFiles])

  useEffect(() => {
    const files = props?.filesProps.files

    if (files?.length) {
      setFileList(files.slice(0, 10))
    }
  }, [props?.filesProps.files])

  useEffect(() => {
    if (props?.filesProps.files) {
      setFileList(props?.filesProps.files)
    }
  }, [props.filesProps.files])

  useEffect(() => {
    if (!props?.isVisible) {
      setDuplicateError(false)
      setInvalidFileError(false)
      setInvalidFileNameError(false)
      setListOfErrors({
        duplicates: [],
        invalidFileNames: [],
        invalidFiles: [],
      })
    }
  }, [props?.isVisible])

  useEffect(() => {
    const noFilesCondition =
      props.fileError &&
      props.filesProps.files.length === 0 &&
      !over10FilesError &&
      !duplicateError &&
      !invalidFileError &&
      !invalidFileNameError

    const over10FilesCondition =
      props.filesProps.files.length > 10 &&
      !duplicateError &&
      !invalidFileError &&
      !invalidFileNameError
    setNoFilesError(Boolean(noFilesCondition))
    setOver10FilesError(Boolean(over10FilesCondition))
  }, [
    props?.filesProps.files,
    props?.fileError,
    over10FilesError,
    duplicateError,
    invalidFileError,
    invalidFileNameError,
  ])
  // Replace the lastUploadedFile when replaceFile is true
  useEffect(() => {
    if (props.replaceFileProps.replaceFile && lastUploadedFile) {
      // Replace or add the lastUploadedFile to fileList
      setFileList((prevFileList) => {
        const updatedFileList = prevFileList.map((file) =>
          file.name === lastUploadedFile.name ? lastUploadedFile : file
        )
        // If no file was replaced, add it to the list
        const isFileReplaced = prevFileList.some((file) => file.name === lastUploadedFile.name)
        return isFileReplaced ? updatedFileList : [...updatedFileList, lastUploadedFile]
      })

      // Update props.filesProps to add or replace the file
      props.filesProps.setFiles((prevFiles) => {
        const updatedFilesProps = prevFiles.map((file) =>
          file.name === lastUploadedFile.name ? lastUploadedFile : file
        )
        // If the file wasn't in the list, add it
        const isFileReplacedInProps = prevFiles.some((file) => file.name === lastUploadedFile.name)
        return isFileReplacedInProps ? updatedFilesProps : [...updatedFilesProps, lastUploadedFile]
      })
    }
  }, [props.replaceFileProps.replaceFile, lastUploadedFile])

  return (
    <div className='attachments'>
      <div className='formgroup'>
        {props?.label && (
          <InputLabel
            className={props?.inputProps?.className}
            infoLabel={props?.info}
            isinfoClassName={props?.infoClassName}
            isinfoIcon={props?.infoIcon}
            isinfoLabel={props?.isInfo}
            label={props?.label}
            labelProps={{ htmlFor: props?.inputProps?.id }}
            mandatory={props?.isMandatory}
          />
        )}
        <div
          aria-label='Attachment'
          className='attachfile dropzonecontrol'
          id='form-file-upload'
          ref={attachmentRef}
          tabIndex={0}
        >
          <div
            className='drop-file-input'
            onClick={(e) => addFilePopup(e)}
            onDragEnter={onDragEnter}
            onDragLeave={onDragLeave}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => handleDrop(e)}
            ref={wrapperRef}
          >
            <label
              aria-label='Choose/Drag files'
              className='choosebtn font-12 title-color30  sourcesanspro pointer-events-all'
              htmlFor='attachFile'
              onClick={(e) => addFileHandler(e)}
              title='Choose/Drag files'
            >
              Choose/Drag files
            </label>
            <input
              accept='.xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf,.png, .jpg, .jpeg,.gif, .msg'
              aria-label='Attach File'
              id='attachFile'
              multiple
              name='attachFile'
              onChange={onFileDrop}
              type='file'
            />

            {fileList.length > 0 ? (
              <div className='attachmentsdisplay'>
                <ul className='formattach' id='attachments'>
                  {fileList.map((item: any, index: number) => (
                    <li key={getItemName(item)}>
                      <div
                        aria-label={getItemName(item)}
                        className='attachedfiles'
                        tabIndex={0}
                        title={getItemName(item)}
                      >
                        {renderFileNameWithIcon(item.name ?? item.fileName)}
                        <span
                          aria-label='Close'
                          className='icon-close'
                          onClick={(e) => {
                            e.preventDefault()
                            fileRemove(item)
                          }}
                          onKeyDown={() => fileRemove(item)}
                          tabIndex={0}
                          title='Close'
                        ></span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
            {renderErrorMessages()}
            <span className='errormsg' id='docerrormsg' style={{ verticalAlign: 'bottom' }}>
              {/* {duplicateError && fileExistsErrorMessage} */}
              {invalidFileError && invalidFileErrorMessage}
              {invalidFileNameError && invalidFileNameErrorMessage}
              {noFilesError && noFilesExistErrorMessage}
              {over10FilesError && over10FilesErrorMessage}
            </span>
          </div>
        </div>
        {props?.hint && (
          <span
            aria-label={props?.hint}
            aria-live='polite'
            className='hintmsg d-block sourcesanspro font-12 title-color2 '
            tabIndex={0}
          >
            <span className={props?.hintClassName}>Hint:</span> {props?.hint}
          </span>
        )}
        {props?.note && (
          <span
            aria-live='polite'
            className='hintmsg sourcesanspro font-12 title-color2'
            tabIndex={0}
          >
            <span className={props?.noteClassName}>Note:</span> {props?.note}
          </span>
        )}
        {duplicateError ? (
          <Alert
            btn1className='btn-border-radius-3 px-2 btn-primary whitetext poppins-medium font-12 text-uppercase btn-xs'
            btn1iconclassNmae='icon-rb-checked  font-12 pe-1'
            btn2classNmae='btn-border-radius-3 px-2 btn-border-1 darktext poppins-medium font-12 text-uppercase btn-xs'
            btn2iconclassNmae='icon-rb-close  font-12 pe-1'
            cancel='Cancel'
            className='alert-info'
            message={`File(s) with the name(s) ${formatFileDuplicates(
              listOfErrors.duplicates
            )} already exist. Do you want to replace them?`}
            onClick={onRespondClick}
            yes='Replace'
          />
        ) : (
          ''
        )}
      </div>
    </div>
  )
}
FileUpload.propTypes = {
  onFileChange: PropTypes.func,
}
export default FileUpload
